export enum CostType {
  // Pflegekosten
  CARE = 'CARE',
  // Unterkunftskosten
  ACCOMMODATION = 'ACCOMMODATION',
  // Verpflegungskosten
  LODGING = 'LODGING',
  // Investitionskosten
  INVESTMENT = 'INVESTMENT',
  // Vergütungszuschlag nach § 43b SGB XI (§ 84 Abs. 8) [HVP: EAB]
  SURCHARGE_43B = 'SURCHARGE_43B',
  // Vergütungszuschlag nach § 132g Abs. 3 SGB V
  SURCHARGE_84_9 = 'SURCHARGE_84_9',
  // Ausbildungsumlage
  TRAINING_LEVY = 'TRAINING_LEVY',
  // Pflege-Hilfsmittel
  CARE_AIDS = 'CARE_AIDS',
  // Reisekosten
  TRAVEL_EXPENSES = 'TRAVEL_EXPENSES',
  // Wahlleistung
  OPTIONAL_SERVICE = 'OPTIONAL_SERVICE',
  // Andere
  OTHER = 'OTHER',
}
